import { apiGet } from 'shared/services/api/resource';
import { PLAYER_SPORT_LEVELS, PlayerSportLevel } from 'modules/jogador/profile/content';

export function fetchPlayerSportLevels(): Promise<PlayerSportLevel[]> {
  return apiGet(PLAYER_SPORT_LEVELS, '/me/sport-levels');
}
